import { CONTRACT_BUY_INTL_PREFIX } from './ContractBuy';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Link from '@material-ui/core/Link';
import PropTypes from 'prop-types';

const AlertBody = styled.div`
  display: flex;
  .message {
    margin-right: 15px;
  }
  .link {
    text-transform: uppercase;
    cursor: pointer;
  }
`;

export const SuccessSnackBar = ({ link }) => {
  return (
    <AlertBody>
      <div className={'message'}>
        <FormattedMessage id={`${CONTRACT_BUY_INTL_PREFIX}.buySuccess`} />
      </div>
      <Link
        className={'link'}
        onClick={() => {
          window.location.href = link;
        }}>
        <FormattedMessage id={`${CONTRACT_BUY_INTL_PREFIX}.showBought`} />
      </Link>
    </AlertBody>
  );
};

SuccessSnackBar.propTypes = {
  link: PropTypes.string,
};
